export default __webpack_public_path__ + "static/media/oval-reversed.0cc15915.svg";